import { SupportedCurrencies, toBool } from 'vopay';
import { usePaymentMethods as useSharedPaymentMethods } from 'shared/contacts';
import { useClientData } from '@/providers/ClientData.provider';

export type { AddInteracParams, PaymentMethod, PaymentMethodType } from 'shared/contacts';

type HookProps = {
  accountID?: string;
  currencies?: SupportedCurrencies[];
};

// Thin adapter over shared/contacts' usePaymentMethods: same call signature
// as the old portal hook (account facts derived from the ClientData provider),
// one implementation. Loading indication is the CALLER's job — every consumer
// wraps the mutations in its own blocking-loader raise.
export default function usePaymentMethods({ accountID, currencies = ['CAD'] }: HookProps = { currencies: ['CAD'] }) {
  const { response } = useClientData();

  return useSharedPaymentMethods({
    accountID,
    currencies,
    clientAccountsEnabled: toBool(response.ClientAccountsEnabled),
    loginUserName: response.LoginUserName,
  });
}
